import { get, post } from './requests'

export const getAgency = key => payload =>
  get(['agency-hours'], { key, params: { listing: payload } })
export const sendPipedriveAgencyLeadData = payload => post(['pipedrive-agency'], {}, payload)
